import React, { useContext, useEffect, useState } from "react";
import { Layout } from "@shopify/polaris";
import { useQuery } from "@apollo/react-hooks";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

import constant from "lib/constant/constant";

// import helper
import { baseHelper } from "lib/helpers";

import { PrivateContext } from "lib/context/privateContext";

// import queries
import { GET_METAFIELD_SETTING, GET_PRODUCT_AND_SELLER_PRODUCT } from "app/product/apollo/queries";

// import components
import Banner from "lib/components/banner/banner";
import { SkeletonAnnotated } from "lib/components";

import OperatorEditTabs from "./subFeatures/form/tab";

const OperatorProductEdit = () => {
  const { cms, isLoading, match } = useContext(PrivateContext);
  const [description, setDescription] = useState("");
  const [isMetafield, setIsMetafield] = useState(false);
  const [isVariant, setIsVariant] = useState(false);
  const [title, setTitle] = useState("");

  const [banner, setBanner] = useState({
    action: null,
    children: null,
    isOpen: false,
    status: "",
    title: "",
  });
  const onDismissBanner = () => {
    setBanner({
      action: null,
      children: null,
      isOpen: false,
      status: "",
      title: "",
    });
  };

  const { loading: productLoading, data: productData, refetch } = useQuery(GET_PRODUCT_AND_SELLER_PRODUCT, {
    variables: { input: { _id: match.params.id } },
  });

  const { loading: metafieldLoading, data: metaFieldData } = useQuery(GET_METAFIELD_SETTING);

  useEffect(() => {
    if (metaFieldData) {
      const metafieldSetting = baseHelper.getResponseData(metaFieldData, constant.gql.GET_METAFIELD_SETTING) || {};
      const { metafield = [] } = metafieldSetting;

      if (metafield && metafield.length) {
        setIsMetafield(true);
        return;
      }
      setIsMetafield(false);
    }
  }, [metaFieldData]);

  useEffect(() => {
    if (productData) {
      const productResponse =
        baseHelper.getResponseData(productData, constant.gql.GET_PRODUCT_AND_SELLER_PRODUCT) || {};
      const { variants = [] } = (productResponse && productResponse.sellerProduct) || {};

      if (variants && variants.length) {
        setIsVariant(true);
        return;
      }
      setIsVariant(false);
    }
  }, [productData]);

  if (isLoading || productLoading || metafieldLoading) {
    return <SkeletonAnnotated />;
  }

  return (
    <>
      {banner.isOpen && (
        <Layout.Section>
          <Banner
            title={banner.title}
            status={banner.status}
            isOpen={banner.isOpen}
            action={banner.action}
            onDismiss={onDismissBanner}
          >
            {banner.children}
          </Banner>
        </Layout.Section>
      )}
      <br />
      <Layout.AnnotatedSection title={title} description={description}>
        <OperatorEditTabs
          setBanner={setBanner}
          cms={cms}
          setDescription={setDescription}
          setTitle={setTitle}
          refetch={refetch}
          setIsVariant={setIsVariant}
          isVariant={isVariant}
          isMetafield={isMetafield}
        />
      </Layout.AnnotatedSection>
    </>
  );
};

export default withFeature(withErrorBoundary(OperatorProductEdit), { feature: constant.PRODUCT_UPDATE });
